/* global $ */

import videoHelpers from '../helpers/video';

const $videoOverlay = $('.js-video-overlay');
const $close = $('.js-video-overlay-close');
const $video = $('.js-video-overlay-video');
const $openVideo = $('.js-open-video');
const $window = $(window);

const videoOverlay = {
  initialize() {
    if ($videoOverlay.length) {
      this.createEvents();
    }
  },

  createEvents() {
    $window.on('resize', () => {
      this.setVideoHeight();
    });

    $close.on('click', () => {
      this.closeVideo();
    });

    $openVideo.on('click', (e: any) => {
      e.preventDefault();
      const video = $(e.currentTarget).data('url');
      this.openVideo(video);
    });
  },

  getEmbed(url: string): string {
    const type: string = (url.indexOf('youtube') >= 0 || url.indexOf('youtu.be') >= 0)
      ? 'youtube' : 'vimeo';
    let embed;

    // YouTube specific code
    if (type === 'youtube') {
      const id: string = videoHelpers.getYoutubeId(url);
      embed = videoHelpers.createYoutubeEmbed(id);

    // Vimeo specific code
    } else if (type === 'vimeo') {
      const id: string = videoHelpers.getVimeoId(url);
      embed = videoHelpers.createVimeoEmbed(id);
    }

    return embed;
  },

  setVideoHeight() {
    const CLOSE_HEIGHT: number = 62;
    const RATIO_16_9: number = 0.5625;
    const videoSpace: number = $window.height() - CLOSE_HEIGHT;

    if (($window.width() * RATIO_16_9) > videoSpace) {
      $video.css({
        paddingBottom: 0,
        height: videoSpace,
      });
    } else {
      $video.css({
        paddingBottom: '56.25%',
        height: 'auto',
      });
    }
  },

  openVideo(url: string) {
    const embed: string = this.getEmbed(url);

    $videoOverlay.trigger('show.overlay');

    $video.append(embed);

    $videoOverlay.attr('aria-hidden', 'false');

    this.setVideoHeight();

    $('body').css('overflow', 'hidden');

    $videoOverlay.addClass('is-visible');
  },

  closeVideo() {
    $video.html('');

    $videoOverlay.attr('aria-hidden', 'true');

    $('body').css('overflow', 'visible');

    $videoOverlay.removeClass('is-visible');
  },
};

export default videoOverlay;
